import { useState } from "react";

export function UpdatesSection() {
	const [showAll, setShowAll] = useState(false);

	const updates = [
		{ date: "JUNE 2026", text: "Our TuRTLe journal paper was accepted to ACM TODAES 2026. Added a graph of each table view" },
			{ date: "APR 2026", text: "NotSoTiny accepted at DAC 2026 (Long Beach, CA)! Added Gemma-4-31B to the leaderboard; really strong performance on RTL tasks given its small size" },
		{ date: "MAR 2026", text: "Added SOTA OSS models Kimi-K2.5, GLM-5, and IndustrialCoder to the leaderboard" },
		{ date: "FEB 2026", text: "Brand new UI for the TuRTLe leaderboard built using React" },
		{ date: "DEC 2025", text: "We introduce a brand new benchmark for Module Completion, based on Tiny Tapeout with more than 1000 real-world designs" },
		{ date: "NOV 2025", text: "We release a new codebase TuRTLe v2 with API support and local Docker evaluation. Added Kimi K2 Inst, DeepSeek V3.1 Terminus, and Google's Gemini 2.5 Flash" },
		{ date: "OCT 2025", text: "Added Hermes-4-14B, Qwen3-8B, and Seed-OSS-36B to the leaderboard. Implemented Other Models tab and moved models to it" },
		{ date: "SEPT 2025", text: "Added gpt-oss-20b and gpt-oss-120b to the leaderboard" },
		{ date: "JULY 2025", text: "Our TuRTLe paper was accepted to MLCAD 2025 in September (Santa Cruz, CA)" },
		{ date: "JUNE 2025", text: "We make our framework open-source on GitHub and we add 7 new recent models! For a total of 40 base and instruct models and 5 RTL benchmarks" }
	];

	const getOpacity = (index) => {
		if (showAll) return 1;
		const opacities = [1, 1, 0.6, 0.35, 0.18, 0.01, 0.01, 0.01, 0.01, 0.01];
		return opacities[index] || 1;
	};

	const maskStyle = showAll
		? {}
		: {
			maskImage: 'linear-gradient(to bottom, black 0%, black 30%, transparent 100%)',
			WebkitMaskImage: 'linear-gradient(to bottom, black 0%, black 30%, transparent 100%)'
		};

	return (
		<div className="w-full max-w-5xl mx-auto mb-0" style={{ marginBottom: showAll ? '1rem' : '-100px' }}>
			<div
				className="border border-gray-700 rounded-lg bg-gray-900/20 shadow-lg backdrop-blur-sm overflow-hidden relative"
				style={maskStyle}
			>
				<div className="p-3">
					<div className="flex justify-between items-center mb-2">
						<h3 className="text-sm font-semibold text-gray-400 text-left">Updates</h3>
						<button
							onClick={() => setShowAll(!showAll)}
							className="text-xs text-gray-500 hover:text-gray-400 transition-colors cursor-pointer"
						>
							{showAll ? "Show less" : "Show all"}
						</button>
					</div>
					<div className="space-y-1.5">
						{updates.map((update, index) => (
							<div
								key={index}
								className="flex gap-3 text-left"
								style={{ opacity: getOpacity(index) }}
							>
								<span className="text-xs text-gray-500 whitespace-nowrap">{update.date}:</span>
								<span className="text-xs text-gray-400">{update.text.trim()}</span>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
}
